/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  deleteRemoveOrganizationThunk,
  deleteValidateRemoveOrganizationThunk,
  postDeleteOrganizationThunk,
} from './organization.remove.thunk';
import {
  selectDialog,
  selectStatus,
  toggleRemoveOrgDialog,
  toggleResultDialog,
  selectError,
  selectResultDialog,
} from './organization.remove.slice';
import { useUserAccounts } from '../../user/userAccounts/useUserAccounts';

export default function useRemoveOrganization() {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const { user } = useUserAccounts();

  const status = useSelector(selectStatus);
  const removeDialog = useSelector(selectDialog);
  const organizationId = user?.currentOrganizationId;
  const userId = user?.id;
  const error = useSelector(selectError);
  const resultDialog = useSelector(selectResultDialog);

  const onToggleRemoveDialog = open => dispatch(toggleRemoveOrgDialog(open));
  const onToggleResultDialog = (open) => {
    dispatch(toggleResultDialog(open));
    if (typeof error === 'undefined') {
      dispatch(postDeleteOrganizationThunk(userId));
    }
  };

  useEffect(() => {
    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const valiateRemoveOrganization = () => {
    dispatch(deleteValidateRemoveOrganizationThunk({ orgId: organizationId }));
  };

  const onRemoveOrgConfirm = () => {
    dispatch(deleteRemoveOrganizationThunk({ orgId: organizationId }));
  };

  return {
    isLoading,
    removeDialog,
    organizationId,
    valiateRemoveOrganization,
    onRemoveOrgConfirm,
    onToggleRemoveDialog,
    resultDialog,
    onToggleResultDialog,
    error,
  };
}
